<ng-container *ngIf="number; else: noNumber">
  <a [href]="phoneURI" *ngIf="dialpad; else: noDialpadNumber">{{ humanizedPhone }}</a>
  <ng-template #noDialpadNumber>
    <a *ngIf="linkTo" href="{{ linkTo }}" target="_blank">{{ humanizedPhone }}</a>
    <span *ngIf="!linkTo">{{ humanizedPhone }}</span>
  </ng-template>
  <app-copy-to-clipboard *ngIf="allowCopyToClipboard" [text]="humanizedPhone | phoneNumber" />
</ng-container>
<ng-template #noNumber>{{ noValue | blankValueDash }}</ng-template>
